import React, {useState} from 'react';
import {Modal, ModalBody} from "react-bootstrap";
import {updateImage} from "../../services/MediaRepository";
import ImageContent from "../course/ImageContent";


export function ImageGridElement({image}) {

    const[hover, setHover] = useState(false);
    const[editImage, setEditImage] = useState(false);
    const[editedData, setEditedData] = useState(image);


    function updateEntity(field, value) {

        const copy = {...editedData};
        copy[field] = value;
        setEditedData(copy);
    }


    return (
        <div className={"m-2 mb-3 border bg-white d-flex flex-column justify-content-start align-items-center"} style={{minHeight:"98%"}} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            <Modal show={editImage} centered={true}  onHide={() => setEditImage(false)}>
                <Modal.Header closeButton >
                    <Modal.Title>
                        Rediger bilde
                    </Modal.Title>
                </Modal.Header>

                <ModalBody>
                    <div className={"d-flex flex-column"}>
                        <input className={"form-control mb-2"} type={"text"} placeholder={image.alt ? image.alt : "Alternativ tekst (ingen verdi)"} onChange={(e) => updateEntity("alt", e.target.value)}/>
                        <input className={"form-control mb-2"} type={"text"} placeholder={image.description ? image.description : "Beskrivelse av bilde til intern bruk (ingen verdi)"} onChange={(e) => updateEntity("description", e.target.value)}/>
                        <input className={"form-control mb-2"} type={"number"}  min={1} placeholder={image.width} onChange={(e) => updateEntity("width", parseInt(e.target.value))}/>
                        <input className={"form-control mb-2"} type={"number"} min={1} placeholder={image.height} onChange={(e) => updateEntity("height", parseInt(e.target.value))}/>
                        <button className={"btn btn-success"} onClick={() => updateImage(editedData)}>Lagre</button>
                    </div>

                </ModalBody>

            </Modal>
            <div className={"p-2"}>
                {
                    hover ?
                        <button className={"btn btn-warning "} onClick={() => setEditImage(true)}>Rediger</button>
                        :
                        <p><strong>BILDE</strong></p>
                }

                <p><strong>ID:</strong> {image.hash}</p>
                <p><strong>Beskrivelse:</strong>{image.description == "" ? " TOM" : image.description}</p>
                <p><strong>Alt:</strong>{image.alt == "" ? " TOM" : image.alt}</p>
                <p><strong>Filnavn: </strong>{image.filename}</p>
            </div>

            <ImageContent format={image.format} url={image.url}  style={{maxWidth:"90%"}} className={"border border-2 border-dark"} />

            <button className={"btn btn-dark mt-2"} onClick={() => navigator.clipboard.writeText("![]("+image.url+")")}>Kopier</button>


        </div>
    );

}